module.exports = __webpack_public_path__ + "static/img/manualOnline.c172f17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/manualOnline.png
// module id = AETJ
// module chunks = 12